import React from 'react';
import { View, Pressable, ScrollView } from 'react-native';
import { Text } from '@/components/ui/text';
import type { OnboardingIntent } from '../types';

interface IntentCaptureScreenProps {
  onSelect: (intent: OnboardingIntent) => void;
  onNext: () => Promise<void>;
  selectedIntent?: OnboardingIntent;
  isAdvancing: boolean;
}

const INTENT_OPTIONS: { id: OnboardingIntent; label: string; description: string }[] = [
  { id: 'REVIEWER', label: 'Rate a dish I just had', description: 'Share your thoughts on what you ate' },
  { id: 'WISHLIST_BUILDER', label: 'Save somewhere I want to try', description: 'Build a list of places to visit' },
  { id: 'TRACKER', label: 'Track where I\'ve been', description: 'Log your dining experiences' },
];

export function IntentCaptureScreen({ onSelect, onNext, selectedIntent, isAdvancing }: IntentCaptureScreenProps) {
  return (
    <View className="flex-1 px-6 pt-4">
      <ScrollView className="flex-1" showsVerticalScrollIndicator={false} contentContainerStyle={{ flexGrow: 1 }}>
        <Text className="text-xl font-bold text-foreground mb-2">
          What sounds most fun to start with?
        </Text>
        <Text className="text-sm text-muted-foreground mb-6">
          You can do all of these later.
        </Text>

        <View className="gap-3 mb-8">
          {INTENT_OPTIONS.map((option) => (
            <Pressable
              key={option.id}
              testID={`intent-${option.id}`}
              onPress={() => onSelect(option.id)}
              className={`rounded-lg border p-4 ${
                selectedIntent === option.id ? 'border-primary bg-primary/10' : 'border-border'
              }`}
            >
              <Text className="text-base font-semibold text-foreground">{option.label}</Text>
              <Text className="text-sm text-muted-foreground mt-1">{option.description}</Text>
            </Pressable>
          ))}
        </View>
      </ScrollView>

      <Pressable
        onPress={onNext}
        disabled={!selectedIntent || isAdvancing}
        accessibilityLabel="Continue"
        className="bg-primary rounded-lg py-3 px-8 mb-4"
        style={{ opacity: !selectedIntent || isAdvancing ? 0.5 : 1 }}
      >
        <Text className="text-primary-foreground text-base font-semibold text-center">
          Continue
        </Text>
      </Pressable>
    </View>
  );
}
